module.exports = __webpack_public_path__ + "img/logo.3aa94fa6.png";